var render = function render(){var _vm=this,_c=_vm._self._c;return _c('riskWarn',{attrs:{"domain":"social","pageTitle":"社保夯实率预警","themeColor":"#00C48C","subTabs":['社保夯实率'],"showAmount":true}})
}
var staticRenderFns = []

export { render, staticRenderFns }